/* global filter_obj */
const $ = jQuery.noConflict();
$(document).ready(function() {

    /** Load More Blog */
    $(document).on('click', '.news-listing-component .load-more-news', function() {
        const $component = $('.news-listing-component');
        $component.find('.no-more-result').hide();
        $component.find('.load-more-img').show();
        $component.find('.load-more-link').hide();

        const posts_per_page = $component.find('#posts_per_page').val();
        const input_page_num = parseInt($component.find('#input_page_num').text()) + 1;
        $component.find('#input_page_num').text(input_page_num);

        ajax_news_filter(input_page_num, posts_per_page);
    });

});

function ajax_news_filter(input_page_num, posts_per_page) {
    const $component = $('.news-listing-component');

    jQuery.ajax({
        url: filter_obj.ajax_url,
        type: 'POST',
        dataType: 'json', // Expect JSON response automatically
        data: {
            action: 'ajax_news_filter',
            input_page_num: input_page_num,
            posts_per_page: posts_per_page,
        },
        beforeSend: function() {
            $component.find('.load-more-link').hide();
            $component.find('.load-more-img').show();
        },
        success: function(res) {
            $component.find('.load-more-img').hide();
            $component.find('.load-more-link').show();

            if (res.html && res.html.trim() !== '') {
                $component.find('.card-wrap').append(res.html);
            } else {
                $component.find('.load-more-link').hide();
                // $component.find(".no-more-result").show();
            }

            if (res.next === 0) {
                $component.find('.load-more-link').hide();
                // $component.find(".no-more-result").show();
            }
        },
        error: function() {
            $component.find('.load-more-img').hide();
            $component.find('.no-more-result').show().text('No more result found');
        },
    });
}
